import { OffersAndMetadata } from '@wwt/entities/search-response'

export const checkOfferExistsInPages = (
	pages: OffersAndMetadata[],
	offerId: string
): boolean => {
	for (const page of pages) {
		if (page.offers.some(offer => offer.IDs.nonPersistingOfferId === offerId)) {
			return true
		}
	}

	return false
}
